export enum FormMode {
    Creation = 1,
    Edition = 2,
    Reading = 3,
    Designer = 4,
}
